export default "__VITE_ASSET__378cf290__"